"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GoGoIcon = exports.CombinationOfferIcon = exports.DiscountIcon = exports.ShippingIcon = void 0;

var _react = _interopRequireDefault(require("react"));

var _localShipping = _interopRequireDefault(require("react-icons/lib/md/local-shipping"));

var _percent = _interopRequireDefault(require("react-icons/lib/fa/percent"));

var _localOffer = _interopRequireDefault(require("react-icons/lib/md/local-offer"));

var _contentCopy = _interopRequireDefault(require("react-icons/lib/md/content-copy"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var nudgeIconStyle = {
  x: '7',
  y: '4',
  height: '1.1em',
  width: '1.1em',
  className: 'icon-check__nudge'
};

var ShippingIcon = function ShippingIcon(_ref) {
  var rest = Object.assign({}, _ref);

  var svgProps = _objectSpread({
    fill: 'currentColor',
    preserveAspectRatio: 'xMidYMid meet',
    height: '1em',
    width: '1em',
    viewBox: '0 0 40 40',
    style: {
      verticalAlign: 'middle'
    }
  }, rest);

  return _react.default.createElement("svg", svgProps, _react.default.createElement(_localShipping.default, _extends({}, rest, nudgeIconStyle)));
};

exports.ShippingIcon = ShippingIcon;

var DiscountIcon = function DiscountIcon(_ref2) {
  var rest = Object.assign({}, _ref2);

  var svgProps = _objectSpread({
    fill: 'currentColor',
    preserveAspectRatio: 'xMidYMid meet',
    height: '1em',
    width: '1em',
    viewBox: '0 0 40 40',
    style: {
      verticalAlign: 'middle'
    }
  }, rest);

  return _react.default.createElement("svg", svgProps, _react.default.createElement(_percent.default, _extends({}, rest, nudgeIconStyle)));
};

exports.DiscountIcon = DiscountIcon;

var CombinationOfferIcon = function CombinationOfferIcon(_ref3) {
  var rest = Object.assign({}, _ref3);

  var svgProps = _objectSpread({
    fill: 'currentColor',
    preserveAspectRatio: 'xMidYMid meet',
    height: '1em',
    width: '1em',
    viewBox: '0 0 40 40',
    style: {
      verticalAlign: 'middle'
    }
  }, rest);

  return _react.default.createElement("svg", svgProps, _react.default.createElement(_localOffer.default, _extends({}, rest, nudgeIconStyle)));
};

exports.CombinationOfferIcon = CombinationOfferIcon;

var GoGoIcon = function GoGoIcon(_ref4) {
  var rest = Object.assign({}, _ref4);

  var svgProps = _objectSpread({
    fill: 'currentColor',
    preserveAspectRatio: 'xMidYMid meet',
    height: '1em',
    width: '1em',
    viewBox: '0 0 40 40',
    style: {
      verticalAlign: 'middle'
    }
  }, rest);

  return _react.default.createElement("svg", svgProps, _react.default.createElement(_contentCopy.default, _extends({}, rest, nudgeIconStyle)));
};

exports.GoGoIcon = GoGoIcon;